import { NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { HomeComponent } from "./components/home/home/home.component";
import { MyPageComponent } from "./components/pages/my-page/my-page.component";
import { LoginComponent } from "./components/pages/login/login.component";
import { NeedAuthGuardService } from "./services/Auth/need-auth-guard.service";
import { NgxPermissionsService } from "ngx-permissions";
import { Location } from "@angular/common";
import { CustomerService } from "./services/login.service";
import { Keywords } from "./enums/kewords.enum";

const routes: Routes = [
  { path: "login", component: LoginComponent },
  {
    path: "Notification",
    component: HomeComponent,
  },
    {
    path: "home",
    component: HomeComponent,
    canActivate: [NeedAuthGuardService], // <---- connected Route with guard
    children: [
      {
        path: "my-page",
        component: MyPageComponent
      },
      {
        path: "users",
        loadChildren: ()=>import('./modules/users/users.module').then(m => m.UsersModule)
      },
      {
        path: "privileges",
        loadChildren: ()=>import('./modules/privileges/privileges.module').then(m => m.PrivilegesModule)
      },
      {
        path: "settings",
        loadChildren: ()=>import('./modules/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'commerce',
        loadChildren: () => import('./modules/commerce/commerce.module').then(m => m.CommerceModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule)
      }

    ]
  },
  { path : '**', redirectTo: 'home'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{enableTracing: false, useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {

  route: string;

  constructor(
    location: Location,
     router: Router,
     private ngxPermissionsService : NgxPermissionsService,
     private customerService: CustomerService,
     ) {
    // within our constructor we can define our subscription
    // and then decide what to do when this event is triggered.
    // in this case I simply update my route string.
    router.events.subscribe(val => {
      if (location.path() != "") {
        this.route = location.path();
        if(this.customerService.isLogged() && sessionStorage.getItem(Keywords.USER_PERMISSIONS))
          this.ngxPermissionsService.loadPermissions(JSON.parse(sessionStorage.getItem(Keywords.USER_PERMISSIONS)));
      } else {
      }
    });}
}
